module.exports = __webpack_public_path__ + "static/img/khl_03.b9d40f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/khl_03.jpg
// module id = 2N0G
// module chunks = 0